import { useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export function useLocalizedNavigate() {
  const navigate = useNavigate()
  const { i18n } = useTranslation()

  return useCallback(
    (to: string | number, options?: { replace?: boolean }) => {
      if (typeof to === 'number') {
        navigate(to)
        return
      }
      // Prefix absolute paths with language
      if (to.startsWith('/')) {
        navigate(`/${i18n.language}${to}`, options)
      } else {
        navigate(to, options)
      }
    },
    [navigate, i18n.language]
  )
}
